import { render, staticRenderFns } from "./UserProfileView.component.vue?vue&type=template&id=407d2128"
import script from "./UserProfileView.component.vue?vue&type=script&lang=js"
export * from "./UserProfileView.component.vue?vue&type=script&lang=js"
import style0 from "./UserProfileView.component.vue?vue&type=style&index=0&id=407d2128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports